import styled from "styled-components";

export const Profile = styled.div`
  height: 100%;
  overflow: scroll;
  padding: 100px 20% 0;
`;

export const ProfilePicture = styled.img`
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  height: 100px;
  margin-bottom: 20px;
`;

export const UserName = styled.h4`
  margin: 20px 0;
`;

export const Email = styled.h4`
  margin: 20px 0;
`;